<script>
import {customReport, deleteRecord, oliRecord} from "@/api/sync";
import {Message} from "element-ui";

export default {
  name: 'oliRecord',
  props: {
    officeId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: false,
      equipmentId: null,
      oliRecordList: [],
      current: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      reportVisible: false,
      report : {},
      reportRules : {
        quantity: [
          { required: true, message: '请输入产生量', trigger: 'blur' },
        ]
      }
    }
  },
  computed: {},
  watch: {},
  methods: {
    open(equipmentId) {
      this.equipmentId = equipmentId
      this.visible = true
      this.fetch()
    },

    async fetch() {
      this.loading = true;
      const param = {
        current: this.current,
        size: this.pageSize,
        filter: [
          {
            "name": "equipmentId",
            "value": this.equipmentId,
            "type": "EQ"
          },
        ],
        sorted: [
          {
            "name": "createTime",
            "type": "DESC"
          }
        ]
      }
      const resp = await oliRecord(param)
      if (resp && resp.code === "0000") {
        this.oliRecordList = resp.result.records;
        this.total = resp.result.total;
      }
      this.loading = false;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.fetch();
    },

    handleCurrentChange(val) {
      this.current = val;
      this.fetch();
    },

    async handleCustomReport(){
      if (!this.report.quantity){
        Message.error("产生量未填写")
        return
      }
      const param = {
        equipmentId: this.equipmentId,
        type : 'CUSTOM',
        quantity: this.report.quantity
      }
      const resp = await customReport( param)
      if (resp && resp.code === "0000"){
        if (resp.result && resp.result) {
          Message.success("上报成功")
        }else {
          Message.error("上报失败")
        }
        this.reportVisible = false
      }
      this.fetch();
    },

    // 删除台账记录
    async removeRecord(data){
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const resp = deleteRecord(data.id)
        if (resp && resp.code === "0000"){
          Message.success("撤销成功")
        }
      }).catch(() => {

      });
    }

  },
  mounted() {

  }
}

</script>

<template>
  <div>
    <el-drawer :visible.sync="visible" title="台账记录" direction="btt" size="80vh">
      <div style="display: flex;flex-direction: column; gap: 8px; padding: 20px">
        <el-row type="flex" justify="end">
          <el-button size="mini" type="primary" @click="reportVisible = true" v-if="officeId !== 0">自主上报</el-button>
        </el-row>
        <el-table :data="oliRecordList" highlight-current-row border stripe :loading="loading">
          <el-table-column prop="cspch" label="批次号" min-width="80" show-overflow-tooltip/>
          <el-table-column prop="csl" label="产生量">
            <template slot-scope="scope">
              <span>{{ `${scope.row.csl} ( ${scope.row.jldw} )` }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="fwdlmc" label="大类名称" show-overflow-tooltip />
          <el-table-column prop="fwxxmc" label="小类名称" />
          <el-table-column prop="qx" label="去向" >
            <template slot-scope="scope">
              <span>{{scope.row.qx === '1' ? '贮存入库' : '立产立清转移'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型">
            <template slot-scope="scope">
              <el-tag :type="scope.row.type === 'CUSTOM' ? 'success' : ''">{{ scope.row.typeDesc }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sid" label="市平台id" show-overflow-tooltip />
          <el-table-column prop="syncStatus" label="上报状态" >
            <template slot-scope="scope">
              <el-row type="flex" :gutter="20" style="padding: 0 10px" align="bottom">
                <el-tag :type="scope.row.syncStatus === 1 ? 'success' : 'danger'">{{ scope.row.syncStatus === 1 ? '成功' : '失败' }}</el-tag>
                <el-popover
                    placement="top-start"
                    title="失败原因"
                    width="200"
                    trigger="hover"
                    :content="scope.row.syncMessage"
                    :hidden="scope.row.syncStatus === 1 "
                >
                  <el-link  slot="reference" type="info" style="margin-left: 20px; font-size: 12px">失败原因</el-link>
                </el-popover>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="时间" show-overflow-tooltip/>
<!--          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-row :gutter="8">
                <el-link type="danger" @click="removeRecord(scope.row)">撤销台账记录</el-link>
                <el-dropdown @command="(command) => handleCommand(command, scope.row)">
                  <el-button size="mini" type="text" style="margin-left: 10px; color: #4b5563;">
                    更多<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item command="cancel" style="color: #F56C6C"><span>撤销上报记录</span></el-dropdown-item>

                  </el-dropdown-menu>
                </el-dropdown>
              </el-row>
            </template>
          </el-table-column>-->

        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="current" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total" class="pagination"/>
        </div>

      </div>


    </el-drawer>

    <el-dialog :visible.sync="reportVisible" title="自主上报" width="500" append-to-body>
      <el-form ref="reportFormRef" :model="report" :rules="reportRules" label-position="left" label-width="100">
        <el-form-item label="产生量" prop="quantity">
          <el-input v-model="report.quantity" placeholder="请输入产生量" style="width: 70%;">
            <template slot="append">（千克）</template>
          </el-input>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="end">
        <el-button size="mini" @click="reportVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="handleCustomReport">确定</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<style scoped>
.el-card {
  margin: 16px;
  display: flex;
  flex-direction: column;
}

.el-card .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.el-table {
  flex: 1;
  min-height: 0;
}

.pagination-container {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  text-align: right;
}
</style>
